// Sélecteur Territoire / Audience / Offre — influence directement le
// prochain run pipeline (transmis à /leads-engine/unified-leads).
// Le picker persiste dans localStorage pour ne pas être ressaisi.
import { useEffect } from "react";
import {
  NAVY, CHAMPAGNE, IVORY, SLATE,
} from "@/components/altiora/PremiumUI";

export const PROVINCES = [
  { k: "QC", label: "Québec" },
  { k: "ON", label: "Ontario" },
  { k: "BC", label: "Colombie-Britannique" },
  { k: "AB", label: "Alberta" },
  { k: "NB", label: "Nouveau-Brunswick" },
  { k: "NS", label: "Nouvelle-Écosse" },
];

export const AUDIENCE_TYPES = [
  { k: "dirigeants_pme", label: "Dirigeants PME" },
  { k: "grandes_entreprises", label: "Grandes entreprises" },
  { k: "professionnels", label: "Professionnels indépendants" },
  { k: "particuliers", label: "Particuliers" },
  { k: "partenaires", label: "Partenaires" },
  { k: "evenements", label: "Événements" },
];

export const OFFER_TYPES = [
  { k: "b2b_services", label: "Services B2B" },
  { k: "conseils_pme", label: "Conseils PME" },
  { k: "financiers", label: "Services financiers" },
  { k: "assurance", label: "Assurance" },
  { k: "immobilier_commercial", label: "Immobilier commercial" },
  { k: "technologie", label: "Technologie" },
  { k: "autre", label: "Autre" },
];

const STORAGE_KEY = "altiora_leads_territory_v1";

export function loadPersistedTerritory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed.provinces)) return null;
    return parsed;
  } catch { return null; }
}

export default function TerritoryPicker({ value, onChange }) {
  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); }
    catch { /* localStorage unavailable — safe fallback */ }
  }, [value]);

  const setProvince = (p) => {
    onChange({ ...value, provinces: [p],
                label: PROVINCES.find((x) => x.k === p)?.label || p });
  };
  const setAudience = (a) => {
    onChange({ ...value, audience_types: [a] });
  };
  const setOffer = (o) => {
    onChange({ ...value, offer_type: o });
  };

  const currentProvince = value.provinces?.[0];
  const currentAudience = value.audience_types?.[0];

  return (
    <div data-testid="territory-picker"
         className="mt-6 rounded-xl bg-white p-4"
         style={{ border: `1px solid ${CHAMPAGNE}33` }}>
      <div className="grid gap-4 md:grid-cols-3">
        <label className="block">
          <span className="text-[10px] font-mono uppercase tracking-[0.24em]"
                style={{ color: SLATE }}>Territoire</span>
          <select data-testid="picker-province"
                  value={currentProvince || "QC"}
                  onChange={(e) => setProvince(e.target.value)}
                  className="mt-2 w-full rounded-md p-2 text-[13px]"
                  style={{ background: IVORY,
                           border: `1px solid ${CHAMPAGNE}55`,
                           color: NAVY }}>
            {PROVINCES.map((p) => (
              <option key={p.k} value={p.k}>{p.label}</option>
            ))}
          </select>
        </label>
        <label className="block">
          <span className="text-[10px] font-mono uppercase tracking-[0.24em]"
                style={{ color: SLATE }}>Audience</span>
          <select data-testid="picker-audience"
                  value={currentAudience || "dirigeants_pme"}
                  onChange={(e) => setAudience(e.target.value)}
                  className="mt-2 w-full rounded-md p-2 text-[13px]"
                  style={{ background: IVORY,
                           border: `1px solid ${CHAMPAGNE}55`,
                           color: NAVY }}>
            {AUDIENCE_TYPES.map((a) => (
              <option key={a.k} value={a.k}>{a.label}</option>
            ))}
          </select>
        </label>
        <label className="block">
          <span className="text-[10px] font-mono uppercase tracking-[0.24em]"
                style={{ color: SLATE }}>Offre</span>
          <select data-testid="picker-offer"
                  value={value.offer_type || "b2b_services"}
                  onChange={(e) => setOffer(e.target.value)}
                  className="mt-2 w-full rounded-md p-2 text-[13px]"
                  style={{ background: IVORY,
                           border: `1px solid ${CHAMPAGNE}55`,
                           color: NAVY }}>
            {OFFER_TYPES.map((o) => (
              <option key={o.k} value={o.k}>{o.label}</option>
            ))}
          </select>
        </label>
      </div>
      <p className="mt-3 text-[11px]" style={{ color: SLATE }}>
        Ces paramètres influencent le prochain croisement multi-sources —
        scoring, pertinence, WHY FOR ME et Next Best Action.
      </p>
    </div>
  );
}
